import { render, staticRenderFns } from "./FormatPageObjectDragTracker.vue?vue&type=template&id=1e63a8af&"
import script from "./FormatPageObjectDragTracker.vue?vue&type=script&lang=ts&"
export * from "./FormatPageObjectDragTracker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports